import { useEffect, useState, useCallback } from "react";
import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";

export default function WebsiteManagement() {
  const [sites, setSites] = useState([]);
  const [form, setForm] = useState({ name: "", display_name: "" });
  const [busy, setBusy] = useState(false);

  const load = useCallback(() => { api.get("/sites").then((r) => setSites(r.data)).catch(() => {}); }, []);
  useEffect(() => { load(); }, [load]);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/sites", form);
      toast.success("Website dibuat");
      setForm({ name: "", display_name: "" });
      load();
    } catch (err) { toast.error(formatApiError(err.response?.data?.detail)); }
    finally { setBusy(false); }
  };

  const toggle = async (s) => {
    try {
      await api.put(`/sites/${s.site_id}`, { status: s.status === "ACTIVE" ? "INACTIVE" : "ACTIVE" });
      load();
    } catch (err) { toast.error(formatApiError(err.response?.data?.detail)); }
  };

  return (
    <div data-testid="website-management-page">
      <div className="section-head">Website Management</div>
      <form onSubmit={submit} style={{ maxWidth: 520, marginBottom: 20 }} data-testid="site-form">
        <div className="form-row"><label>Site Name</label>
          <input className="form-input" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} data-testid="site-name" required /></div>
        <div className="form-row"><label>Display Name</label>
          <input className="form-input" value={form.display_name} onChange={(e) => setForm({ ...form, display_name: e.target.value })} data-testid="site-display" required /></div>
        <div className="form-row"><label></label>
          <button className="btn btn-primary" disabled={busy} data-testid="site-submit">+ Buat Website</button></div>
      </form>

      <table className="panel-table" data-testid="sites-table">
        <thead><tr><th>Site ID</th><th>Site Name</th><th>Display Name</th><th>Status</th><th>Created At</th><th>Aksi</th></tr></thead>
        <tbody>
          {sites.length === 0 && <tr className="empty-row"><td colSpan={6}>Belum ada website</td></tr>}
          {sites.map((s) => (
            <tr key={s.site_id} data-testid={`site-row-${s.site_id}`}>
              <td><b>{s.site_id}</b></td>
              <td>{s.name}</td>
              <td>{s.display_name}</td>
              <td><span className={`status-pill ${s.status === "ACTIVE" ? "status-RUNNING" : "status-FINISHED"}`}>{s.status}</span></td>
              <td className="nowrap">{new Date(s.created_at).toLocaleString("sv-SE").replace("T", " ")}</td>
              <td><a className="link-blue" onClick={() => toggle(s)} data-testid={`toggle-${s.site_id}`}>{s.status === "ACTIVE" ? "Nonaktifkan" : "Aktifkan"}</a></td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
